import { gql } from '@apollo/client';

export const fetchCampaignReviewQuery = gql`
  query getCampaignReview($id: Long!) {
    campaign(id: $id) {
      id
      name
      createdAt
      startAt
      endedAt
      messageMedium
      dataScienceOptimizations
      mobileAppIds
      priorityLevel
      labels {
        id
        name
      }
      customConversion {
        eventName
        attributionMode
      }
      campaignTypeDefinition
      lists {
        name
      }
      suppressionLists {
        name
      }
      expectedSendSize
      campaignState
      templateId
      experiments {
        id
        name
      }
      schedulerMsgParams {
        automaticSendTime
      }
    }
  }
`;
export const fetchTemplateReviewQuery = gql`
  query getTemplateReview($id: Long!) {
    template(id: $id) {
      name
      id
      contentPreview
      contentId
      locales {
        languageName
        tag
      }
    }
  }
`;

export const fetchCampaignsReviewQuery = gql`
  fragment campaignsReviewPageInfo on Campaigns {
    info {
      limit
      offset
    }
  }

  query getCampaignsReview {
    campaigns {
      ...campaignsReviewPageInfo
      results {
        id
        name
        workflow {
          id
          name
          allNodes {
            id
            resource {
              ... on CampaignNodeResource {
                campaign {
                  id
                }
              }
            }
          }
        }
      }
    }
  }
`;
